<template>
	<v-container id="container" class="py-0 fill-height" fluid>
		<v-slide-x-transition mode="out-in">
			<v-row
				:key="'loading'"
				v-if="mode === modes.loading"
				justify="center"
				align="center"
			>
				<v-col cols="auto">
					<font-awesome-icon icon="sync" spin size="4x"></font-awesome-icon>
				</v-col>
			</v-row>
			<component
				:is="styleComponents.board"
				v-else-if="mode === modes.board && styleComponents"
				@show-result="displayResult"
			>
			</component>
			<component
				:is="styleComponents.roulette"
				v-else-if="mode === modes.roulette && styleComponents"
				:result="result"
			>
			</component>
			<winning-numbers-display
				v-else-if="
					mode === modes.sortitionDisplayResult &&
					displaySortition &&
					resultForDisplay
				"
				:sortition="displaySortition"
				:result="resultForDisplay"
				@show-board="mode = modes.board"
			></winning-numbers-display>

			<v-row
				:key="'not-found'"
				v-else-if="mode === modes.notFound"
				justify="center"
				align="center"
			>
				<v-col cols="auto" class="text-center">
					<h1>
						Please contact support, looks like your page is not configured.
					</h1>
					<p>
						<font-awesome-icon
							:icon="['fas', 'robot']"
							size="4x"
						></font-awesome-icon>
					</p>
				</v-col>
			</v-row>
		</v-slide-x-transition>
	</v-container>
</template>

<script>
import PageStyle from '../../enumerations/PageStyle.json';
import { fetchStyleConfiguration } from '../../api/homepage.api.js';
import { getStyleName } from '../../utils.js';
import WinningNumbersDisplay from './WinningNumbersDisplay';
import { fetchDisplaySortition } from '../../api/homepage.api';

const modes = {
	board: 1,
	roulette: 2,
	loading: 3,
	notFound: 4,
	sortitionDisplayResult: 5
};

const pageStyles = PageStyle;

export default {
	name: 'Homepage',
	components: { WinningNumbersDisplay },
	data() {
		return {
			modes,
			pageStyles,
			mode: modes.board,
			result: null,
			// {
			// 	numbers: [
			// 		{
			// 			playType: {
			// 				id: 4,
			// 				name: 'Pick 2'
			// 			},
			// 			digits: '23'
			// 		},
			// 		{
			// 			playType: {
			// 				id: 5,
			// 				name: 'Cash 3'
			// 			},
			// 			digits: '234'
			// 		},
			// 		{
			// 			playType: {
			// 				id: 6,
			// 				name: 'Play 4'
			// 			},
			// 			digits: '3678'
			// 		},
			// 		{
			// 			playType: {
			// 				id: 7,
			// 				name: 'Pick 5'
			// 			},
			// 			digits: '90123'
			// 		}
			// 	],
			// 	sortition: 'LUCKY LOTTO 12PM'
			// },
			resultForDisplay: null,
			displaySortition: null,
			style: null,
			resultFields: [],
			styleComponents: null
		};
	},
	methods: {
		async displayResult(result) {
			this.resultForDisplay = result;
			const { data } = await fetchDisplaySortition(result.sortition_display_id);
			this.displaySortition = data.sortition;
			if (this.resultForDisplay && this.displaySortition) {
				this.mode = modes.sortitionDisplayResult;
			}
		}
	},
	watch: {
		style(style) {
			const styleName = getStyleName(style);
			import(`../components/pageStyles/${styleName}/css/main.scss`);
			this.styleComponents = {
				board: () => import(`../components/pageStyles/${styleName}/Board.vue`),
				roulette: () =>
					import(`../components/pageStyles/${styleName}/Roulette.vue`)
			};
		}
	},
	async created() {
		try {
			const response = await fetchStyleConfiguration();

			this.style = response.data.style;
			this.resultFields = response.data.resultFields;
			await this.$nextTick();
			this.mode = modes.board;
		} catch (e) {
			this.mode = modes.notFound;
		}
		this.$root.$on('sortition-time', async (result) => {
			this.result = result;
			await this.$nextTick();
			this.mode = modes.roulette;
		});

		this.$root.$on('sortition-time-done', async () => {
			this.mode = modes.board;
			await this.$nextTick();
			this.result = null;
		});

		//! Comment this.
		// this.$root.$emit('sortition-time', this.result);
	}
};
</script>

<style>
/* //! Todo Remove this. */
html {
	overflow-y: hidden;
}
</style>
